export default __webpack_public_path__ + "static/media/dapprader.a9145acd.jpg";